import styled, { keyframes } from 'styled-components';
import { Input } from '@chakra-ui/input';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const InputFile = styled(Input)`
  opacity: 0;
  width: 1px;
  height: 1px;
`;

export const InputArea = styled.div`
  margin-top: 12px;
  width: 100%;
  height: 122px;
  background-color: ${({ theme }) => theme.colors.white200};
  border-color: ${({ theme }) => theme.colors[700]};
  border: 2px dashed black;
  border-radius: 8px;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  user-select: none;
  color: #000;
  h3 {
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors[1400]};
  }
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.colors[1400]} !important;
    color: black;
    font-weight: 600;
    position: relative;
    z-index: 200;
  }
  margin-bottom: 6px;
`;

const FadeInAnimation = keyframes`
  from {
    overflow: hidden;
    margin-top: 0;
    height: 0;
    opacity: 0;
  }
  to {
    overflow: auto;
    margin-top: 18px;
    height: 44px;
    opacity: 1;
  }
`;

export const FileItem = styled.div`
  width: 100%;
  height: 44px;
  border: 2px solid #bfbfbf;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors[1300]};
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-between; */
  padding: 0 18px;
  margin-top: 8px;
  overflow: auto;
  animation: ${FadeInAnimation} 400ms ease-in 1 forwards;
  transition: all ease-in 400ms;

  a {
    flex: 1;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors[900]} !important;
    gap: 30px;
  }
  p {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    /* color: ${({ theme }) => theme.colors[500]}; */
    span {
      margin-right: 8px;
    }
  }
  button {
    padding: 10px;
    margin-right: -8px;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.6;
    }
  }
`;
